import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, Subscription, interval } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class VersionCheckService implements OnDestroy {
  readonly updateAvailable$ = new Subject<void>();
  private sub: Subscription | null = null;

  constructor(private http: HttpClient) {}

  startPolling(intervalMs = 5 * 60 * 1000) {
    this.fetchVersion().subscribe({
      next: initial => {
        if (initial.buildTime === 0) return; // dev environment placeholder, skip
        this.sub = interval(intervalMs).pipe(
          switchMap(() => this.fetchVersion()),
          filter(v => v.buildTime !== initial.buildTime),
          take(1)
        ).subscribe(() => this.updateAvailable$.next());
      },
      error: () => {}
    });
  }

  private fetchVersion() {
    return this.http.get<{ buildTime: number }>(`/assets/version.json?_=${Date.now()}`);
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }
}
